import { INDUSTRIES } from "@/data/program";
import { motion } from "framer-motion";

export default function Projects() {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="bg-white relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <p className="font-mono uppercase tracking-[0.24em] text-xs text-slate-500 mb-6">
              — Industry Projects
            </p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-slate-900">
              Deployments across<br />
              <span className="italic text-slate-500">six industries.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 self-end">
            <p className="text-slate-600 font-sans leading-relaxed text-lg">
              Every project you build is drawn from a real client scenario —
              chosen for the technical texture, the compliance edges, and the
              production trade-offs that show up on the job.
            </p>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-6 md:gap-8 auto-rows-[220px]">
          {/* Hero image cell */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="col-span-1 md:col-span-8 lg:col-span-8 row-span-2 relative overflow-hidden group"
            data-testid="projects-hero-cell"
          >
            <img
              src="https://images.pexels.com/photos/92904/pexels-photo-92904.jpeg"
              alt="Production code deployed to cloud infrastructure"
              className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-slate-900/40 group-hover:bg-slate-900/20 transition-colors duration-700" />
            <div className="absolute inset-0 p-8 md:p-12 flex flex-col justify-end text-white">
              <p className="font-mono uppercase text-[10px] tracking-[0.24em] text-slate-300 mb-3">
                Capstone · Production system
              </p>
              <h3 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight max-w-lg">
                An end-to-end AI system, deployed on your choice of GCP or Azure.
              </h3>
            </div>
          </motion.div>

          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className={`bg-[#FAFAF7] border border-slate-200 p-6 md:p-8 hover:border-slate-900 transition-colors group ${
                i === 0 ? "md:col-span-4 lg:col-span-4" : "md:col-span-4 lg:col-span-4"
              }`}
              data-testid={`industry-card-${ind.name.toLowerCase()}`}
            >
              <p className="font-mono uppercase text-[10px] tracking-[0.24em] text-slate-500 mb-4">
                {String(i + 1).padStart(2, "0")} · Industry
              </p>
              <h4 className="font-serif text-3xl text-slate-900 tracking-tight mb-3 group-hover:italic transition-all">
                {ind.name}
              </h4>
              <p className="text-slate-600 font-sans text-sm leading-relaxed">
                {ind.detail}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
